import { Divider, HStack, Text, VStack, Box, Tooltip } from "native-base";
import React, { useEffect, useState, useRef } from "react";
import { Loc } from "../../App/Loc";
import { RootStateOrAny, useSelector } from "react-redux";
import helping from "../../assets/images/helping.png";
import { useWindowDimensions } from "react-native";
import { Dimensions } from "react-native";
import AVSelectDropdown from "../../components/common/AVSelectDropdown";
import AVComDropdonwn from "../../components/common/AVComDropdown";
import { CalendarIcon } from "@mui/x-date-pickers";
import { AVCalendarView } from "../../components/common/calendar/AVCalendarView";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import RenderEvents from "../Events/RenderEvents";
import inform from "../../assets/images/inform.png";
import _ from "lodash";
import Filter from "../../components/common/AVFilter";
import { getSeriesItem } from "../../Utility/utils";
import AVEvents from "../../Screens/Events/AVEvents";
import useFetchAllEvents from "../../Hooks/useFetchAllEvents";
import RenderFilters from "../../components/Events/RenderFilters";
import EventCard from "../../components/Events/EventCard";
import { useNavigate } from "react-router-dom";

const ShowEvents = ({ handleEvents, userData, isOwner, isEventPage }) => {
  const dimensions = Dimensions.get("window");
  const isMobile = dimensions?.width <= 500 || false;
  const navigate = useNavigate();
  const currentUser: any = useSelector(
    (state: RootStateOrAny) => state?.user?.user[0]
  );
  const { events, loading, error } = useFetchAllEvents(
    currentUser,
    userData?.id
  );

  const [allEventData, setEventData] = React.useState<any>(events);
  const [allEvents, setAllEvents] = React.useState<any>(events);
  const [filteredEvents, setFilteredEvents] = React.useState<any>([]);
  const [isCalendarView, setIsCalenderView] = useState(true);
  const [categories, setCategories] = useState<any>([]);
  const [selectedFilter, setSelectedFilter] = useState("Current");

  useEffect(() => {
    setEventData(events);
    setAllEvents(events);

    const currentEvents = events?.filter(
      (ev) => !isCanceled(ev) && new Date(ev.end) >= new Date()
    );

    setFilteredEvents(currentEvents);
    setSelectedFilter("Current");

    const uniqueCategories = [
      "Current",
      ...new Set(currentEvents.map((event) => event.linkType)),
    ];
    const past = events?.filter(
      (ev) => new Date(ev.end) < new Date() && !isCanceled(ev)
    );
    const canceled = events?.filter((ev) => isCanceled(ev));
    if (past?.length > 0) uniqueCategories.push("Past");
    if (canceled?.length > 0) uniqueCategories.push("Canceled");
    setCategories(uniqueCategories.filter(Boolean));
  }, [events, loading]);

  const isCanceled = (event: any) =>
    event?.data?.toLowerCase() === "canceled" ||
    event?.status?.toLowerCase() === "canceled";

  const handleFilters = (filter) => {
    try {
      setSelectedFilter(filter);
      setFilteredEvents([]);
      const now = new Date();
      let filteredEvents = [];

      switch (filter) {
        case "Past":
          filteredEvents = events.filter(
            (event) => new Date(event.end) < now && !isCanceled(event)
          );
          break;
        case "Canceled":
          filteredEvents = events.filter((event) => isCanceled(event));
          break;
        case "Current":
          filteredEvents = events?.filter(
            (event) => !isCanceled(event) && new Date(event.end) >= now
          );
          break;
        default:
          filteredEvents = events.filter(
            (event) =>
              event.linkType === filter &&
              !isCanceled(event) &&
              new Date(event.end) >= now
          );
          break;
      }
      setFilteredEvents(filteredEvents);
    } catch (e) {
      console.error("Error in filtering the results", e);
    }
  };
  const handleEventClick = (item) => {
    try {
      console.log("handlenavigate", item);
      navigate(
        `/Events/${item?.id}/${item?.region}/${item?.seriesId ?? item.id}`,
        {
          state: { team: item, seriesId: item?.seriesId ?? item.id },
        }
      );
    } catch (e) {
      console.log("Error in opening the Event", e);
    }
  };
  return (
    <>
      <VStack
        p={2}
        backgroundColor={"AVColor.white"}
        minHeight={"340px"}
        width={"100%"}
      >
        <VStack space={5}>
          <EventsMenu
            handleEvents={handleEvents}
            isOwner={isOwner}
            allEventData={allEventData}
            userData={userData}
            setIsCalenderView={setIsCalenderView}
            isCalendarView={isCalendarView}
          />
        </VStack>
        <Divider my={2} zIndex={-3} />
        {!isCalendarView && allEventData?.length > 0 && (
          <HStack
            marginY={"24px"}
            overflowX={isMobile ? "scroll" : undefined}
            backgroundColor={"rgba(0,0,0,0.05)"}
            borderRadius={"18px"}
            minWidth={isMobile ? "322px" : ""}
            maxWidth={isMobile ? "322px" : "max-content"}
            left={"10px"}
            height={"36px"}
          >
            {!isCalendarView && (
              <>
                {console.log(categories, "steCategories")}

                {categories?.length > 0 && (
                  <RenderFilters
                    categories={categories}
                    selectedFilter={selectedFilter}
                    handleFilters={handleFilters}
                  />
                )}
              </>
            )}
          </HStack>
        )}

        {!isCalendarView &&
          filteredEvents?.length == 0 &&
          allEventData?.length != 0 && (
          <VStack
            width={"100%"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <HStack padding={"10px"} alignItems={"center"} zIndex={-3}>
              <Text>{Loc.currentLang.menu.noEventsFound}</Text>
            </HStack>
          </VStack>
        )}

        <HStack
          zIndex={-3}
          space={1}
          fontWeight={"500"}
          flexWrap={"wrap"}
          height={"auto"}
          paddingY={"5px"}
          borderRadius={10}
          width={"100%"}
          marginTop={allEventData?.length === 0 ? "10px" : ""}
          justifyContent={
            allEventData?.length === 0 ? "center" : isMobile ? "center" : ""
          }
        >
          {isCalendarView && (
            <AVCalendarView
              data={allEventData?.filter(
                (x) =>
                  x?.data?.toLowerCase() !== "canceled" &&
                  x?.status?.toLowerCase() !== "canceled" &&
                  x?.status?.toLowerCase() !== "no"
              )}
              eventType={Loc.currentLang.menu.current}
            />
          )}
          {!isCalendarView &&
            filteredEvents?.length > 0 &&
            [...filteredEvents]?.map((item, index) => {
              return (
                <Box key={index}>
                  <EventCard
                    item={item}
                    handleEventClick={handleEventClick}
                    isShowRSVP={false}
                  />
                </Box>
              );
            })}
        </HStack>
        {!isCalendarView &&
          filteredEvents?.length == 0 &&
          allEventData?.length == 0 && (
            <HStack
              width={"100%"}
              top={isMobile ? "20px" : "0px"}
              padding={isMobile ? "10px" : "10px"}
              marginTop={isMobile ? "-10px" : "0px"}
              space={isMobile ? 2 : 2}
              zIndex={-3}
            >
              <img src={inform} style={{ width: "20px", height: "20px" }} />
              {Loc.currentLang.helpText.person.eventTab}
            </HStack>
          )}
      </VStack>
    </>
  );
};

const EventsMenu = ({
  handleEvents,
  userData,
  isOwner,
  allEventData,
  setIsCalenderView,
  isCalendarView,
}) => {
  const dimensions = useWindowDimensions();
  const isMobile = dimensions?.width <= 600 || false;
  const [isActives, setIsActives] = useState(false);

  const menuRefs = useRef(null);
  useOutsideAlerter(menuRefs);

  function useOutsideAlerter(ref) {
    React.useEffect(() => {
      let isMounted = true;
      if (isMounted) {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setIsActives(false);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }
      return () => {
        isMounted = false; // Set the flag to false when the component is unmounted
        // Cancel subscriptions or perform any cleanup tasks here
      };
    }, [ref]);
  }

  const HandleSocial = () => {
    handleEvents("Social");
    setIsActives(!isActives);
  };

  const HandleMeeting = () => {
    handleEvents("Meeting");
    setIsActives(!isActives);
  };

  const dropdownEventValues = [
    {
      id: 3,
      name: Loc.currentLang.menu.socialText,
      flag: allEventData,
      fn: HandleSocial,
    },
    {
      id: 4,
      name: Loc.currentLang.menu.meeting,
      flag: allEventData,
      fn: HandleMeeting,
    },
  ];

  return (
    <>
      <HStack
        justifyContent={"space-between"}
        marginY={"11px"}
        marginX={"10px"}
        alignItems={"center"}
        space={2}
        width={"100%"}
        flexWrap={isMobile ? "wrap" : "nowrap"}
      >
        <HStack
          width={isMobile ? "96%" : "100%"}
          justifyContent={"space-between"}
          marginTop={isMobile ? "14px" : ""}
          marginLeft={"-15px"}
          height={"38px"}
          alignItems={"center"}
        >
          <Text
            fontWeight={"500"}
            marginLeft={"15px"}
            fontSize={"22px"}
            color={"AVColor.primary"}
            py={"12px"}
          >
            {Loc.currentLang.menu.events}
          </Text>

          <HStack space={isMobile ? 2 : 2}>
            {
              <HStack
                space={2}
                alignItems={"center"}
                left={isMobile ? "10px" : "0px"}
              >
                {isCalendarView && (
                  <FormatListBulletedIcon
                    style={{ color: "#00A7BC" }}
                    onClick={() => setIsCalenderView(false)}
                    cursor={"pointer"}
                  />
                )}
                {!isCalendarView && (
                  <CalendarIcon
                    style={{ color: "#00A7BC" }}
                    onClick={() => setIsCalenderView(true)}
                    cursor={"pointer"}
                  />
                )}
              </HStack>
            }
            {userData?.ownedEvents?.length !== 0 && (
              <Tooltip
                label={Loc.currentLang.helpText.person.eventTab}
                w={200}
                left={isMobile ? "10px" : undefined}
              >
                <Box
                  marginRight={"10px"}
                  p={"9px"}
                  left={isMobile ? "10px" : undefined}
                  display={
                    isCalendarView
                      ? ""
                      : allEventData?.length == 0 &&
                        userData?.events?.length == 0
                      ? "none"
                      : ""
                  }
                  shadow={1}
                  zIndex={-3}
                  height={"33px"}
                  backgroundColor={"AVColor.liteBg"}
                  rounded={"full"}
                >
                  <img
                    src={helping}
                    height={"17px"}
                    width={"17px"}
                    alt="Help"
                  />
                </Box>
              </Tooltip>
            )}
            {isOwner && (
              <>
                <HStack
                  top={isMobile ? "0px" : "0px"}
                  right={isMobile ? "0px" : "0px"}
                >
                  <AVComDropdonwn dropdownValues={dropdownEventValues} />
                </HStack>
              </>
            )}
          </HStack>
        </HStack>
      </HStack>
    </>
  );
};

export default ShowEvents;
